import { formatPriceInput } from '../services/formatPrice';

/**
 * Serializes `form.orderBumps` ({ [productId]: quantity }, 0/absent =
 * deselected) into the submission shape the API validates:
 * `[{ productId, quantity, payWhatYouWantAmount? }]`. Callers append it to a
 * request body only when non-empty so bump-free submissions stay
 * byte-identical.
 *
 * The amount comes from a sibling map rather than the quantity entry: a bump's
 * form value has always been a bare number, and PWYW is the only thing that
 * needs more. Absent for every fixed-price bump, which is what keeps those
 * submissions unchanged.
 *
 * The buyer types major units; the API takes an integer in minor units.
 * `formatPriceInput` is what makes that safe for zero-decimal currencies like
 * JPY, so the currency has to come along. It returns a string, which the API's
 * schema refuses.
 */
export default function getOrderBumpValues(formOrderBumps, formOrderBumpAmounts, currency) {
  if (!formOrderBumps) return [];

  return Object.entries(formOrderBumps)
    .filter(([, quantity]) => Number(quantity) > 0)
    .map(([productId, quantity]) => {
      const amount = formOrderBumpAmounts?.[productId];

      return {
        productId,
        quantity: Number(quantity),
        ...(amount != null &&
          amount !== '' && { payWhatYouWantAmount: Number(formatPriceInput(amount, currency)) }),
      };
    });
}
